import * as React from 'react';
import {
  Typography, Paper, Avatar,
} from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { colors } from '../../../theme';
import globalUseStyles from '../../../globalClasses';

const useStyles = makeStyles(() => createStyles({
  root: {
    height: 58,
    width: 112,
    borderRadius: 5,
    padding: '10px 11px 10px 11px',
  },
  firstLine: {
    paddingBottom: '0.5rem',
  },
  secondLine: {
    display: 'flex',
    alignItems: 'center',
  },
  primaryText: {
    fontSize: '18px',
    marginBottom: '.125em',
    fontWeight: 600,
    letterSpacing: '1.25px',
    lineHeight: '21.09px',
  },
  secondaryText: {
    fontSize: '0.75rem',
    margin: 0,
  },
  paper: {
    marginTop: '0.75rem',
    width: '100%',
  },
  textCount: {
    marginLeft: '5px',
    textAlign: 'center',
  },
}));

interface StatusCardProps {
  primaryText: string,
  secondaryText: string,
  icon: React.ReactElement,
  iconColor: 'green' | 'red' | 'orange' | 'yellow' | 'maroon',
}

const StatusCard: React.FC<StatusCardProps> = ({
  primaryText, secondaryText, icon, iconColor,
}) => {
  const classes = useStyles();
  const globalStyles = globalUseStyles();

  const iconColorClass = () => {
    if (iconColor === 'green') {
      return globalStyles.greenIcon;
    }
    if (iconColor === 'orange') {
      return globalStyles.orangeIcon;
    }
    if (iconColor === 'yellow') {
      return globalStyles.yellowIcon;
    }
    if (iconColor === 'maroon') {
      return globalStyles.maroonIcon;
    }
    return globalStyles.redIcon;
  };

  const textColorClass = () => {
    if (iconColor === 'green') {
      return colors.green;
    }
    if (iconColor === 'orange') {
      return colors.orange;
    }
    if (iconColor === 'yellow') {
      return colors.yellow;
    }
    if (iconColor === 'maroon') {
      return colors.maroon;
    }
    return colors.red;
  };
    // Render
  return (
    <Paper className={classes.paper}>
      <div className={clsx(classes.root)}>
        <div className={classes.firstLine}>
          <Typography className={classes.secondaryText} variant="body2">{secondaryText}</Typography>
        </div>
        <div className={classes.secondLine}>
          <Avatar className={clsx(globalStyles.smallAvatar, iconColorClass())}>
            {icon}
          </Avatar>
          <div className={classes.textCount} style={{ color: textColorClass() }}>
            <Typography className={classes.primaryText} variant="body2">{primaryText}</Typography>
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default StatusCard;
